<!-- Button -->
<div
  class="gd-list-table-button">
  <button
    type="button"
    mat-flat-button
    [color]="buttonColDef.color"
    [disabled]="buttonColDef.disabled && buttonColDef.disabled(data)"
    (click)="buttonColDef.click(data)">
    {{buttonColDef.buttonLabel(data)}}
  </button>
</div>
